// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

type ColorIndicatorProps = {
  backgroundColor: string;
};

export const ColorIndicator = styled.div<ColorIndicatorProps>`
  width: 16px;
  min-width: 16px;
  height: 16px;
  margin-right: 8px;
  border-radius: 8px;
  flex: 0 0 auto;
  background-color: ${props => props.backgroundColor};
`;
ColorIndicator.displayName = 'S.ColorIndicator';

export const RunName = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  flex: 1 1 auto;
`;
RunName.displayName = 'S.RunName';
